<h1 mat-dialog-title>CANCEL ORDER</h1>
<div mat-dialog-content>
    <p>Your order would be cancelled. Do you want to continue?</p>
</div>
<div style="text-align: right; margin-top: 20px">
    <button btn-border (click)="close()" style="margin-right: 15px; min-width: 80px; color: #000; border: 1px solid #000">
        NO
    </button>
    <button data-test="confirm-cancel" style="min-width: 80px" btn-primary cdkFocusInitial (click)="confirm()">YES</button>
</div>
